import React from "react";
import Typography from "@mui/material/Typography";

/**
 * Common typography building blocks.
 *
 * Use these instead of ad‑hoc <Typography> so
 * heading / subheading / label levels stay consistent.
 */

export const PageHeading = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="h6"
    sx={{
      fontWeight: 600,
      fontSize: 18,
      mb: 2,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const SectionHeading = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="subtitle1"
    sx={{
      fontWeight: 600,
      fontSize: 18,
      mb: 2,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const SectionSubHeading = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="body1"
    sx={{
      fontWeight: 500,
      fontSize: 16,
      color: "text.secondary",
      mb: 1,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const LabelText = ({
  children,
  sx = {},
  strong = false,
  noWrap = false,
  ...props
}) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: strong ? 600 : 500,
      fontSize: 14,
      color: "text.secondary",
      whiteSpace: noWrap ? "nowrap" : undefined,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const ValueText = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: 500,
      fontSize: 14,
      minWidth: 0,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const InfoPairLabel = ({ children, sx = {}, ...props }) => (
  <LabelText
    sx={{
      minWidth: 140,
      display: "inline-block",
      mr: 1,
      ...sx,
    }}
    {...props}
  >
    {children}
  </LabelText>
);

export const InfoPairValue = ({ children, sx = {}, ...props }) => (
  <ValueText
    sx={{
      display: "inline",
      ...sx,
    }}
    {...props}
  >
    {children}
  </ValueText>
);

// Specialized label for search bars like "Search By"
export const SearchSectionLabel = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="body2"
    sx={{
      fontSize: 14,
      color: "text.secondary",
      alignSelf: { xs: "flex-start", md: "center" },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);


